import {
    Component,
    Input,
    Output,
    EventEmitter,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ColourPaletteType, IDropdown, SizeType } from '@dxp/core/models';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { TelXLDropdownBaseComponent } from './dropdown.base.component';

@Component({
    selector: 'telxl-multiselect-dropdown',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLDropdownBaseComponent],
    template: `
        <telxl-dropdown-base
            [menuItems]="menuItems"
            [selected]="selected"
            [multiSelect]="true"
            [colour]="colour"
            [position]="position"
            [outline]="outline"
            [disabled]="disabled"
            [size]="size"
            [class]="class"
            [text]="text"
            [placeholder]="placeholder"
            [maxHeight]="maxHeight"
            (selectedChange)="handleSelectedChange($event)"
        ></telxl-dropdown-base>
    `,
})
export class TelXLMultiselectDropdownComponent<T> {
    @Input({ required: true }) menuItems: IDropdown<T>[] = [];
    @Input({ required: true }) colour!: ColourPaletteType;
    @Input() position: Placement = 'bottom-start';
    @Input() selected!: T[];
    @Input() outline = false;
    @Input() disabled = false;
    @Input() size: SizeType | null = null;
    @Input() class = '';
    @Input() text = '';
    @Input() placeholder = '';
    @Input() maxHeight = '100vh';

    @Output() selectedChange = new EventEmitter<T[]>();

    handleSelectedChange(event: T | T[]) {
        this.selectedChange.emit(event as T[]);
    }
}
